import React from "react";
import { useTranslation } from "react-i18next";
import logoPilari from "../assets/images/pilari_light.png";
import logoGZW from "../assets/images/gzw.png";
import { UserMinus } from "lucide-react";

const AccountDeletionPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100 transition-colors duration-300 py-24 px-4 font-sans">
      <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 rounded-3xl shadow-xl overflow-hidden transition-colors duration-300">

        {/* Hero Section */}
        <div className="relative h-[320px] sm:h-[400px]">
          <img
            src={require("../assets/images/cikuray.webp")}
            alt="Gunung Cikuray"
            className="absolute inset-0 w-full h-full object-cover brightness-75"
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-6">
            <img
              src={logoPilari}
              alt="Logo PILARI"
              className="w-20 sm:w-24 mb-3 drop-shadow-md"
            />
            <h1 className="text-3xl sm:text-4xl font-bold drop-shadow-lg">
              {t("accountDeletion.title")}
            </h1>
            <p className="text-sm sm:text-base font-medium drop-shadow-sm mt-2">
              {t("accountDeletion.subtitle")}
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div className="p-8 space-y-8 text-sm sm:text-base text-gray-700 dark:text-gray-200 leading-relaxed">
          {/* Informasi Permintaan Penghapusan */}
          <section className="text-center">
            <h2 className="text-lg font-semibold text-red-700 flex justify-center items-center gap-2 mb-2">
              <UserMinus className="w-5 h-5" />
              {t("accountDeletion.requestTitle")}
            </h2>
            <p>{t("accountDeletion.requestDesc")}</p>
          </section>

          {/* Langkah-langkah */}
          <section>
            <h3 className="font-semibold text-gray-800 dark:text-gray-100 mb-1">
              {t("accountDeletion.stepsTitle")}
            </h3>
            <ol className="list-decimal list-inside space-y-1 text-gray-600 dark:text-gray-300">
              <li>{t("accountDeletion.steps.1")}</li>
              <li>{t("accountDeletion.steps.2")}</li>
              <li>{t("accountDeletion.steps.3")}</li>
              <li>{t("accountDeletion.steps.4")}</li>
            </ol>
          </section>

          {/* Catatan Tambahan */}
          <section>
            <h3 className="font-semibold text-gray-800 dark:text-gray-100 mb-1">
              {t("accountDeletion.notesTitle")}
            </h3>
            <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-300">
              <li>{t("accountDeletion.notes.1")}</li>
              <li>{t("accountDeletion.notes.2")}</li>
              <li>{t("accountDeletion.notes.3")}</li>
            </ul>
          </section>

          <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
            {t("accountDeletion.common.lastUpdated", { date: "Mei 2025" })}
          </p>
        </div>

        {/* Footer */}
        <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 text-center py-4">
          <div className="inline-flex items-center justify-center gap-2 text-xs text-gray-500 dark:text-gray-400">
            <span>{t("accountDeletion.footer.organizedBy")}</span>
            <img src={logoGZW} alt="Garut Zero Waste" className="h-8" />
          </div>
        </footer>
      </div>
    </div>
  );
};

export default AccountDeletionPage;
